import { render } from "./Implants.vue?vue&type=template&id=51e1e18d"
import script from "./Implants.vue?vue&type=script&lang=js"
export * from "./Implants.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__